import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function RoundedChevron({ ...props }: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: `RoundedChevron`,
    path: (
      <>
        <path
          fill="none"
          d="M5.25 8.625L12 15.375L18.75 8.625"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon w="element.md" h="element.md" {...validateKeys(props)} />;
}
